import React from 'react';

const GenericTable = ({ parks, handleRowClick }) => {
  console.log('parks', parks);
  return (
    <div style={{ paddingBottom: 60, width: '50%' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr style={{ borderBottom: '2px solid #000' }}>
            <th style={{ width: '10%', padding: '16px', borderBottom: '1px solid #ddd', fontWeight: 'bolder' }}>Alpha</th>
            <th style={{ width: '30%', padding: '16px', borderBottom: '1px solid #ddd', fontWeight: 'bolder' }}>Name</th>
            <th style={{ width: '10%', padding: '16px', borderBottom: '1px solid #ddd', fontWeight: 'bolder' }}>Code</th>
          </tr>
        </thead>
        <tbody>
          {parks.map((result) => (
            <tr key={result.id} onClick={() => handleRowClick(result)} style={{ cursor: 'pointer', borderBottom: '1px solid #ddd' }}>
              <td style={{ padding: '16px', textAlign: 'center'}}>{result.alpha}</td>
              <td style={{ padding: '16px', textAlign: 'center' }}><span style={{color: "#0000EE"}}>{result.name}</span></td>
              <td style={{ padding: '16px', textAlign: 'center' }}>{result.code}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default GenericTable;
